import { useEffect, useState } from 'react';
import type { SearchResult } from '../../shared/search';
import { adminApi } from '../lib/api';
import { scheduleSearch } from '../lib/search';

type SearchState =
  | { key: string; status: 'loading' }
  | { key: string; status: 'error' }
  | { key: string; status: 'ready'; results: SearchResult[]; has_more: boolean };

export function useScriptSearch(query: string, view: 'active' | 'archived' | null, revision: number) {
  const key = JSON.stringify([query, view, revision]);
  const [state, setState] = useState<SearchState>({ key: '', status: 'loading' });

  useEffect(() => {
    setState({ key, status: 'loading' });
    if (!query || !view) return;
    return scheduleSearch(
      (signal) => adminApi.searchScripts(query, { view, signal }),
      (response) => setState({ key, status: 'ready', ...response }),
      () => setState({ key, status: 'error' }),
    );
  }, [query, view, key]);

  // Hide the preceding query/view synchronously, before effect cleanup runs.
  // The keyed ready state also prevents an empty-state flash while typing.
  return state.key === key ? state : { key, status: 'loading' as const };
}
